export const toTimestamp = (date: Date) =>
    parseInt((date.getTime() / 1000).toFixed(0), 10);
export const getCurrentTimestamp = () => toTimestamp(new Date());

export const timestampToDate = (timestamp: number) =>
    new Date(+timestamp * 1000);
